module.exports = __webpack_public_path__ + "static/img/04996745.a95cf5da.png";